import { FeatureFlagRow } from 'components/settings/internalConfig/FeatureFlagRow';
import { useFeatureFlags } from './hooks/useFeatureFlags';
import { FEATURE_FLAGS, type FeatureFlagConfig } from './config';

const FeatureFlags = (): JSX.Element => {
  const { featureFlags, handleToggleChange, savingFlag } = useFeatureFlags();

  return (
    <div className="py-4 max-w-2xl">
      <h2 className="text-xl font-semibold text-gray-blue-80 leading-7">
        Feature Flags
      </h2>
      <p className="font-normal text-sm leading-5 text-gray-blue-70">
        Below are the list of features that you can enable or disable for this
        customer store.
      </p>

      {FEATURE_FLAGS.map((flag: FeatureFlagConfig) => (
        <FeatureFlagRow
          key={flag.id}
          id={flag.id}
          title={flag.title}
          description={flag.description}
          checked={featureFlags[flag.key as keyof typeof featureFlags]}
          disabled={flag.disabled || savingFlag === flag.key}
          onChange={(checked: boolean) => handleToggleChange(flag.key, checked)}
        />
      ))}
    </div>
  );
};

export default FeatureFlags;
